import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { SEO } from '../components/SEO';

const cookieContent = {
  it: {
    title: 'Cookie Policy',
    lastUpdate: 'Ultimo aggiornamento: 23 Febbraio 2026',
    sections: [
      {
        title: 'Cosa sono i Cookie',
        content: `I cookie sono piccoli file di testo che i siti visitati inviano al browser dell'utente, dove vengono memorizzati per essere ritrasmessi agli stessi siti alla visita successiva.

I cookie possono essere "di sessione" (temporanei, eliminati alla chiusura del browser) o "persistenti" (rimangono nel dispositivo per un periodo determinato).`
      },
      {
        title: 'Cookie Utilizzati da Questo Sito',
        content: `**Cookie Tecnici Necessari**
Questi cookie sono essenziali per il funzionamento del sito e non possono essere disattivati. Includono:

| Cookie | Durata | Finalità |
|--------|--------|----------|
| cookie_consent | 12 mesi | Memorizza le preferenze sui cookie |
| session_id | Sessione | Gestione della sessione utente |
| language | 12 mesi | Memorizza la lingua preferita |

**Cookie Analitici (previo consenso)**
Utilizziamo questi cookie per analizzare in forma aggregata e anonima come gli utenti utilizzano il sito:

| Cookie | Durata | Finalità |
|--------|--------|----------|
| _ga | 24 mesi | Google Analytics - distingue gli utenti |
| _gid | 24 ore | Google Analytics - distingue gli utenti |
| _gat | 1 minuto | Google Analytics - limita le richieste |

**Cookie di Marketing (previo consenso)**
Attualmente non utilizziamo cookie di marketing o profilazione.`
      },
      {
        title: 'Come Gestire i Cookie',
        content: `Puoi gestire le tue preferenze sui cookie in qualsiasi momento:

1. **Banner Cookie:** Clicca sull'icona Cookie nel footer per modificare le tue preferenze
2. **Impostazioni Browser:** Puoi configurare il browser per rifiutare tutti o alcuni cookie

**Come disabilitare i cookie nei principali browser:**
- Chrome: Impostazioni > Privacy e sicurezza > Cookie
- Firefox: Opzioni > Privacy e sicurezza > Cookie
- Safari: Preferenze > Privacy > Cookie
- Edge: Impostazioni > Privacy > Cookie

Nota: disabilitare i cookie tecnici potrebbe compromettere il funzionamento del sito.`
      },
      {
        title: 'Cookie di Terze Parti',
        content: `Questo sito può incorporare contenuti di terze parti (es. mappe Google) che potrebbero impostare propri cookie. Non abbiamo controllo su questi cookie.

Per maggiori informazioni:
- Google: https://policies.google.com/privacy`
      },
      {
        title: 'Aggiornamenti',
        content: `Questa Cookie Policy può essere aggiornata periodicamente. Ti invitiamo a consultare questa pagina regolarmente.

Per domande sulla nostra Cookie Policy: privacy@accordinicarillo.it`
      }
    ]
  },
  en: {
    title: 'Cookie Policy',
    lastUpdate: 'Last updated: February 23, 2026',
    sections: [
      {
        title: 'What are Cookies',
        content: `Cookies are small text files that websites send to the user's browser, where they are stored to be retransmitted to the same sites on the next visit.

Cookies can be "session" (temporary, deleted when the browser is closed) or "persistent" (remain on the device for a determined period).`
      },
      {
        title: 'Cookies Used by This Site',
        content: `**Necessary Technical Cookies**
These cookies are essential for the site to function and cannot be disabled. They include:

| Cookie | Duration | Purpose |
|--------|----------|---------|
| cookie_consent | 12 months | Stores cookie preferences |
| session_id | Session | User session management |
| language | 12 months | Stores preferred language |

**Analytical Cookies (with consent)**
We use these cookies to analyze in aggregate and anonymous form how users use the site:

| Cookie | Duration | Purpose |
|--------|----------|---------|
| _ga | 24 months | Google Analytics - distinguishes users |
| _gid | 24 hours | Google Analytics - distinguishes users |
| _gat | 1 minute | Google Analytics - throttles requests |

**Marketing Cookies (with consent)**
We currently do not use marketing or profiling cookies.`
      },
      {
        title: 'How to Manage Cookies',
        content: `You can manage your cookie preferences at any time:

1. **Cookie Banner:** Click the Cookie icon in the footer to modify your preferences
2. **Browser Settings:** You can configure the browser to refuse all or some cookies

**How to disable cookies in main browsers:**
- Chrome: Settings > Privacy and security > Cookies
- Firefox: Options > Privacy & Security > Cookies
- Safari: Preferences > Privacy > Cookies
- Edge: Settings > Privacy > Cookies

Note: disabling technical cookies may compromise site functionality.`
      },
      {
        title: 'Third-Party Cookies',
        content: `This site may embed third-party content (e.g., Google maps) that may set their own cookies. We have no control over these cookies.

For more information:
- Google: https://policies.google.com/privacy`
      },
      {
        title: 'Updates',
        content: `This Cookie Policy may be updated periodically. We invite you to consult this page regularly.

For questions about our Cookie Policy: privacy@accordinicarillo.it`
      }
    ]
  },
  de: {
    title: 'Cookie-Richtlinie',
    lastUpdate: 'Letzte Aktualisierung: 23. Februar 2026',
    sections: [
      {
        title: 'Was sind Cookies',
        content: `Cookies sind kleine Textdateien, die Websites an den Browser des Benutzers senden, wo sie gespeichert werden, um beim nächsten Besuch an dieselben Websites zurückgesendet zu werden.

Cookies können "Sitzungs"-Cookies (temporär, werden beim Schließen des Browsers gelöscht) oder "persistente" Cookies (verbleiben für einen bestimmten Zeitraum auf dem Gerät) sein.`
      },
      {
        title: 'Auf dieser Website verwendete Cookies',
        content: `**Notwendige technische Cookies**
Diese Cookies sind für das Funktionieren der Website unerlässlich und können nicht deaktiviert werden.

**Analytische Cookies (mit Zustimmung)**
Wir verwenden diese Cookies, um in aggregierter und anonymer Form zu analysieren, wie Benutzer die Website nutzen.

**Marketing-Cookies (mit Zustimmung)**
Wir verwenden derzeit keine Marketing- oder Profiling-Cookies.`
      },
      {
        title: 'Aktualisierungen',
        content: `Diese Cookie-Richtlinie kann regelmäßig aktualisiert werden. Wir laden Sie ein, diese Seite regelmäßig zu besuchen.

Bei Fragen zu unserer Cookie-Richtlinie: privacy@accordinicarillo.it`
      }
    ]
  },
  fr: {
    title: 'Politique des Cookies',
    lastUpdate: 'Dernière mise à jour: 23 février 2026',
    sections: [
      {
        title: 'Que sont les Cookies',
        content: `Les cookies sont de petits fichiers texte que les sites web envoient au navigateur de l'utilisateur, où ils sont stockés pour être retransmis aux mêmes sites lors de la prochaine visite.

Les cookies peuvent être "de session" (temporaires, supprimés à la fermeture du navigateur) ou "persistants" (restent sur l'appareil pendant une période déterminée).`
      },
      {
        title: 'Cookies utilisés par ce site',
        content: `**Cookies techniques nécessaires**
Ces cookies sont essentiels au fonctionnement du site et ne peuvent pas être désactivés.

**Cookies analytiques (avec consentement)**
Nous utilisons ces cookies pour analyser de manière agrégée et anonyme comment les utilisateurs utilisent le site.

**Cookies marketing (avec consentement)**
Nous n'utilisons actuellement pas de cookies marketing ou de profilage.`
      },
      {
        title: 'Mises à jour',
        content: `Cette Politique des Cookies peut être mise à jour périodiquement. Nous vous invitons à consulter cette page régulièrement.

Pour toute question sur notre Politique des Cookies: privacy@accordinicarillo.it`
      }
    ]
  }
};

const CookiePolicyPage = () => {
  const { language } = useLanguage();
  const content = cookieContent[language] || cookieContent.it;

  return (
    <div data-testid="cookie-policy-page" className="min-h-screen">
      <SEO page="cookie" />
      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-[#283880]">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center"
          >
            <h1 className="font-['Playfair_Display'] text-4xl md:text-5xl font-bold text-white mb-4">
              {content.title}
            </h1>
            <p className="text-slate-400 text-sm">
              {content.lastUpdate}
            </p>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="space-y-10"
          >
            {content.sections.map((section, index) => (
              <div key={index} className="border-b border-slate-100 pb-8 last:border-0">
                <h2 className="font-['Playfair_Display'] text-xl md:text-2xl font-semibold text-[#283880] mb-4">
                  {section.title}
                </h2>
                <div className="text-[#64748B] leading-relaxed whitespace-pre-line text-sm md:text-base prose prose-slate max-w-none">
                  {section.content}
                </div>
              </div>
            ))}
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default CookiePolicyPage;
